
import React, { useState } from "react";
import "./Roofrepair.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Working_at_Height() {



  return (

    <div className="Roofrepair-page">
      <div className="Roofrepair-hero">
        <div className="Roofrepair-overlay">
          <h1>      עבודה בגובה  </h1>
        </div>
<div>
</div>
</div>
    <div className="page3">
 <div className="breadcrumb3">
  <Link to="/">בית</Link> /{" "}
  <Link to="/ProfessionalInformation"> מידע מקצועי</Link>/{" "}
    <Link to="/Working_at_Height">     עבודה בגובה  </Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page4">
  <div className="container">


    <div className="content-row">

      <div className="image-box">
        <img src="/images/5.jpg" alt="roof" />
      </div>
      <div className="text-box">



    <h2 className="main-title">
עבודה בגובה – הדרך לאיטום גגות, פתרון לנזילות



    </h2>

        <p>     כל עבודה המתבצעת במקום הגבוה משני מטרים או מקום שניתן ליפול ממנו לפחות שני מטרים מטה, נחשבת לעבודה במקום גבוה. גם עבודת איטום באזור שלא הוכשר לעבודה – אין בו משטח עבודה, נחשב לעבודה כזו, כל עבודה הדורשת הרמת פיגומים או סל הרמה נחשבת גם היא לעבודה במקום גבוה. כמו כן, אם במהלך העבודה יש להטות את הגוף בזווית רחבה מ 45 מעלות, נחשבת העבודה לעבודה במקום גבוה. על העובדים בעבודה כזו חלה חובת הדרכה, עבודה כזו היא מסוכנת ועלולה לסכן את בריאותו של העובד.     </p>



      </div>




    </div>

    <h2 className="main-title">
עבודה בגובה – לאיזה מקרים זה מתאים, איך מבצעים איטום בגובה בצורה בטוחה.



    </h2>

    <div className="bottom-text">
      <p> שיטת עבודה כזו מתאימה עבור איטום קירות חיצוניים, איתור מוקדים של נזילות, איטום גגות, תיקון גגות רעפים, שיקום מבנים ועוד. לעתים רק שיטה כזו עשויה להיות יעילה, כל הדרכים האחרות לא מאפשרות תוצאות כאלו.
כל תקלה שמתרחשת בבית, כמו נזילה או חדירה של מי גשמים היא מעיקה ומתסכלת, מלבד זאת, בעיות בניה שכאלו מפחיתות מערכה של הדירה. בעוד שבעיות איטום נפוצות בעיקר בקומה הגבוהה ביותר – החשופה לשמש או בבתים חד קומתיים שהתקרה שלהם אינה מוגנת מספיק, הרי שנזילות מתרחשות בדרך כלל בבניינים בעלי מספר קומות, כאשר איטום של רצפת השכן מלמעלה אינו איכותי מספיק ומים מהצנרת שעוברת בין הקומות מוצאים את דרכם לתקרת הבית של השכן, לא נעים אף פעם. </p>



      <p>לפני שמבצעים עבודות שיש בהן סיכון כזה, יש לוודא שהקבלן הינו בעל רישיון לעבודה במקומות גבוהים, כמו כן יש לוודא שהוא עבר הכשרה ייעודית לעבודות כאלו. עבודה באופן כזה חושפת את הפועל לסכנות שונות, גם את הולכי הרגל באזור העבודה, עלולה דרך כזו לסכן, נפילה של פועל מגובה מסוכנת מאד, מקרים כאלו עלולים להיגרם במותו של הנופל ובפציעה של עובר אורח ששהה במקום. גם ציוד כבד עלול למצוא את דרכו למטה כאשר עובדים במקום גבוה בצורה שאינה בטיחותית. לכן, חשוב שהאתר ינוהל תחת פיקוח קפדני, כולל שימוש בכלים חיוניים כמו שעון נוכחות חכם מבית OK2GO, המאפשר בקרה מדויקת על מיקומם וזמני עבודתם של העובדים בגובה. זו הסיבה בגללה יש לנקוט במשנה זהירות לפני שמבצעים כל עבודה כזו, זכרו ששום תקלה בבניה או עבודה בגובה אינה מצדיקה קיפוח חיי אדם.</p>

    <h2 className="main-title">
גם כאשר מדובר בתקלה רצינית, הבטיחות חשובה יותר, יש לבצע את כל העבודות באופן זהיר ומעוגן בחוק.

    </h2>

    </div>


     <ContactSection2/>
<div className="links">

  <Link to="/Hot_tar" className="link-right" >    זפת חם </Link>
  <Link to="/Working_in_abseiling" className="link-left" >  עבודה סנפלינג  </Link>

</div>

      </div>
    </div>
  

      </div>
  );
}

